import React from 'react';
import { Icon, Button } from '@iq/react-components';
import classnames from 'classnames';

import { TYPES } from '../../../bundles/notifications';

const ICONS = {
  info: 'he-info',
  success: 'he-statushealthy',
  warning: 'he-statusrisk',
  error: 'he-statusrisk',
  alert: 'he-statusrisk',
  normal: 'he-statushealthy',
};

const Notification = ({
  notification,
  onClear = () => ({}),
  onExpand = () => ({}),
  depth = 0,
  stacked = false,
  colorPanel = false,
}) => {
  const { type, title, message, extra, status, read, visible, id, items } = notification;

  const actionable = (!visible || type === TYPES.actionable) && typeof onClear === 'function';
  const expandable = items && items.length > 1;
  const expanded = !items;

  const icon = ICONS[status] || 'he-statushealthy';

  const className = classnames('notification', {
    read,
    filled: colorPanel,
    removable: actionable,
    expanded,
    stacked,
    actionable,
  });

  let messageGroup = message ? <div className="message">{message}</div> : null;
  if (Array.isArray(message)) {
    messageGroup = message.map((message_, index) => {
      const key = `message-${index}`;
      return (
        <div
          key={key}
          className="message"
        >
          {message_}
        </div>
      );
    });
  }

  return (
    <div
      className={className}
      style={{
        top: `${4 * depth}px`,
        left: `-${4 * depth}px`,
      }}
    >
      <div className={`notification-wrapper ${status || 'info'}`}>
        <div className={`notification--icon ${status || 'info'}`}>
          <Icon icon={icon} />
        </div>
        <div className="notification--body">
          <div className="title">{title}</div>
          {messageGroup && <div className="message">{messageGroup}</div>}
          {!!extra && <div className="muted">{extra}</div>}
        </div>
        {colorPanel && expandable && (
          <Button
            className="expand"
            activity="secondary"
            design="outlined"
            slim
            onClick={(event) => onExpand(event, id)}
          >
            Expand
          </Button>
        )}
        {colorPanel && actionable && !expandable && (
          <Button
            className="clear"
            activity="secondary"
            design="outlined"
            slim
            onClick={(event) => onClear(event, id)}
          >
            Dismiss
          </Button>
        )}
        {!colorPanel && actionable && (
          <Icon
            className="notification--close"
            icon="he-close"
            size="xs"
            onClick={(event) => onClear(event, id)}
          />
        )}
      </div>
    </div>
  );
};

export default Notification;
